/** *
 * 签约场景 LOAN：借款，REPAY：还款
 * */
export enum SceneTypeEnum {
  /** 授信 */
  PREAPPLY = 'PREAPPLY',
  /** 提现借款 */
  LOAN = 'LOAN',
  /** 还款 */
  REPAY = 'REPAY',
}

/** 补充字段-服务接口入参场景值 */
export enum SupplySceneEnum {
  /** 授信 */
  PRE_APPLY = 'preApply',
  /** 提现 */
  LOAN_APPLY = 'loanApply',
}

/** *
 * 签约场景 LOAN：借款，REPAY：还款, 用于埋点录入
 * */
export enum SceneTypeTargetEnum {
  /** 授信 */
  PREAPPLY = 'credit',
  /** 提现借款 */
  LOAN = 'loan',
  /** 还款 */
  REPAY = 'repay',
}

/**
 * 短信验证码场景
 * ** */
export enum SmsSceneType {
  DEFAULT = 'DEFAULT',
  /**
   * 验证码中断流程，
   * 支持渠道：
   * 小象提现
   * 桔多多提现
   * * */
  BROKEN = 'BROKEN'
}


/**
 * 生成提现订单后跳转到结果页场景
 */
export enum GoResultSceneType {
  /** 去权益购买页且为落地页 */
  ACCELERATERIGHT_ISFIRST = 'accelerateRight_isFirst',
  /** 去权益购买页 */
  ACCELERATERIGHT = 'accelerateRight',
  /** 去申请结果页且为钉钉端 */
  APPLYRESULT_ISDINGTALK = 'applyResult_isDingTalk',
  /** 去申请结果页且为落地页 */
  APPLYRESULT_ISFIRST = 'applyResult_isFirst',
  /** 去申请结果页 */
  APPLYRESULT = 'applyResult',
}
